import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { fadeIn, fadeInOut, fadeOut } from "src/app/animations";
import { TipoProduto } from "src/app/shared/enum/tipo-produto";
import { UsuarioService } from "src/app/shared/services/usuario.service";
import { DeclarationService } from "../../services/saude/declaration.service";
@Component({
  selector: 'app-solicitar-declaracao',
  templateUrl: './solicitacao-declaracao.component.html',
  styleUrls: ['./solicitacao-declaracao.component.css'],
  animations: [fadeIn, fadeOut, fadeInOut]
})
export class SolicitacaoDeclaracaoComponent {
  product = TipoProduto;
  productId: any;
  loading: boolean = false;
  loadingProducts: boolean = false;
  loadingModels: boolean = false;
  loadingFilter: boolean = false;
  yearsList: any;
  //Listas
  defaultMonths: any[] = [
    { description: "Janeiro", number: 1 }, { description: "Fevereiro", number: 2 }, { description: "Março", number: 3 }, { description: "Abril", number: 4 },
    { description: "Maio", number: 5 }, { description: "Junho", number: 6 }, { description: "Julho", number: 7 }, { description: "Agosto", number: 8 },
    { description: "Setembro", number: 9 }, { description: "Outubro", number: 10 }, { description: "Novembro", number: 11 }, { description: "Dezembro", number: 12 }
  ];
  //Formulário
  formData: FormGroup = new FormGroup({
    product: new FormControl(null, [Validators.required]),
    model: new FormControl(null, [Validators.required]),
    beneficiary: new FormControl(),
    year: new FormControl(),
    initialMonth: new FormControl(),
    finalMonth: new FormControl(),
    dependent: new FormControl()
  });
  //variaveis
  initialMonthsList!: any[];
  finalMonthsList!: any[];
  productsList: any;
  modelsList: any;
  dependents!: any[];
  beneficiaries!: any[];
  constructor(private route: ActivatedRoute, private toast: ToastrService, private declarationService: DeclarationService, private userService: UsuarioService) {
    this.formData.get('product')?.setValue(Number(this.route.snapshot.queryParams['productId']));
    this.getAllProducts();
    window.location;
  }
  gerarDeclaracao() {
    this.loading = true;
    let paramsToPdf: any = { type: this.formData.value.model, additionalData: {} };
    if (this.formData.value.beneficiary) {
      paramsToPdf.beneficiary = this.formData.value.beneficiary;
    }
    if (this.formData.value.dependent)
      paramsToPdf.dependantCpf = this.formData.value.dependent;
    if (this.formData.value.dependent)
      paramsToPdf.additionalData.dependent = this.formData.value.dependent;
    if (this.formData.value.year)
      paramsToPdf.additionalData.year = this.formData.value.year;
    if (this.formData.value.initialMonth)
      paramsToPdf.additionalData.initialMonth = this.formData.value.initialMonth;
    if (this.formData.value.finalMonth)
      paramsToPdf.additionalData.finalMonth = this.formData.value.finalMonth;
    if (this.formData.value.beneficiary)
      paramsToPdf.additionalData.beneficiary = this.formData.value.beneficiary;
    this.declarationService.postGeneratePDF(paramsToPdf).subscribe({
      next: (data: Blob) => {
        if(data == null){
          this.toast.warning('Não há declarações disponíveis para o período selecionado.');
          this.loading = false
          return
        }
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Declaração de " + (this.productsList.filter((a: any) => a.id == this.formData.value.product)[0].description) + " - " + (this.modelsList.filter((a: any) => a.id == this.formData.value.model)[0].description) + ".pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.loading = false;
        this.toast.success('Declaração gerada com sucesso!');
      },
      error: (error: any) => {
        
        const errorMessage = error.error?.message || "Ocorreu um erro inesperado.";

        this.toast.warning(errorMessage);
      

        this.loading = false;
      }
      
    });
  }
  getAllProducts() {
    this.loadingProducts = true;
    this.declarationService.getProducts().subscribe({
      next: (products: any) => {
        this.productsList = products.filter((a: any) => a.id == this.formData.value.product);
        setTimeout(() => {
          this.onProductChange();
        }, 2000);
        this.loadingProducts = false;
      },
      error: (res: any) => {
        this.loadingProducts = false;
      }
    });
  }
  onModelChange() {
    this.formData.patchValue({ beneficiary: null });
    switch (this.formData.value.model) {
      case 20:
        this.userService.getBeneficiaries().subscribe((res: any) => {
          this.beneficiaries = res;
        });
        this.declarationService.getAvailableMonthlyFees().subscribe((monthsHealth: any) => {
          this.yearsList = monthsHealth.map((mh: any) => {
            return { description: mh.year, months: mh.months };
          });
        });
        break;
      case 19:
        this.userService.getBeneficiaries().subscribe((res: any) => {
          this.beneficiaries = res;
        });
        this.declarationService.getAvailableMonthlyFees().subscribe((monthsHealth: any) => {
          this.yearsList = monthsHealth.map((mh: any) => {
            return { description: mh.year, months: mh.months };
          });
        });
        break;
      case 18:
        this.userService.getBeneficiaries().subscribe((res: any) => {
          this.beneficiaries = res;
        });
        this.declarationService.getAvailableMonthlyFees().subscribe((monthsHealth: any) => {
          this.yearsList = monthsHealth.map((mh: any) => {
            return { description: mh.year, months: mh.months };
          });
        });
        break;
      case 11:
        if (!this.dependents) {
          this.loadingFilter = true;
          this.userService.getBeneficiaries().subscribe((res: any) => {
            this.dependents = res.filter((a: any) => !a.titular);
          }).add(() => {
            //Called when operation is complete (both success and error)
            this.loadingFilter = false;
          });
        }
        break;
      case 13:
        if (!this.beneficiaries) {
          this.loadingFilter = true;
          this.userService.getBeneficiaries().subscribe((res: any) => {
            this.beneficiaries = res;
          }).add(() => {
            //Called when operation is complete (both success and error)
            this.loadingFilter = false;
          });
        }
        break;
      case 8:
      case 9:
      case 10:
        if (this.yearsList == null) {
          this.loadingFilter = true;
          this.declarationService.getAvailableMonthlyFees().subscribe((monthsHealth: any) => {
            this.yearsList = monthsHealth.map((mh: any) => {
              return { description: mh.year, months: mh.months };
            });
          }).add(() => {
            //Called when operation is complete (both success and error)
            this.loadingFilter = false;
          });
        }
        break;
      case 5:
      case 6:
      case 7:
        if (this.yearsList == null) {
          this.loadingFilter = true;
          this.declarationService.getAvailableActiveLinkedSelfSponsoredYears().subscribe((monthsSponsor: any) => {
            monthsSponsor.sort((a: any, b: any) => a > b && -1);
            this.yearsList = monthsSponsor.map((y: any) => {
              return { description: y };
            });
          }).add(() => {
            //Called when operation is complete (both success and error)
            this.loadingFilter = false;
          });
        }
        break;
      case 3:
        this.loadingFilter = true;
        this.declarationService.getDeathPensionBeneficiaries().subscribe((res: any) => {
          this.beneficiaries = res;
          this.yearsList = res[0].years.map((mh: any) => {
            return { description: mh };
          });
        }).add(() => {
          //Called when operation is complete (both success and error)
          this.loadingFilter = false;
        });
        break;
      case 4:
        this.loadingFilter = true;
        this.declarationService.getAlimonyBenefited().subscribe((res: any) => {
          this.beneficiaries = res;
          this.beneficiaries.forEach((a: any) => a.id = a.beneficiaryId);
        }).add(() => {
          //Called when operation is complete (both success and error)
          this.loadingFilter = false;
        });
        break;
    }
  }
  onInitialMonthChange() {
    this.formData.patchValue({ finalMonth: null });
    if (this.showValues('finalMonth')) {
      this.finalMonthsList = this.initialMonthsList.filter((im: any) => im.number >= this.formData.value.initialMonth);
    }
  }
  showValues(value: any): any {
    switch (value) {
      case 'year':
        if ((this.formData.value.model >= 3 && this.formData.value.model <= 10) || this.formData.value.model == 18 || this.formData.value.model == 19 || this.formData.value.model == 20) return true;
        return false;
      case 'initialMonth':
        if (((this.formData.value.model >= 8 && this.formData.value.model <= 10) || this.formData.value.model == 18 || this.formData.value.model == 19 || this.formData.value.model == 20) && this.formData.get('year')) return true;
        return false;
      case 'finalMonth':
        if (((this.formData.value.model >= 8 && this.formData.value.model <= 10) || this.formData.value.model == 18 || this.formData.value.model == 19 || this.formData.value.model == 20) && this.formData.get('initialMonth')) return true;
        return false;
      case 'beneficiary':
        if (this.formData.value.model == 4 || this.formData.value.model == 13 || this.formData.value.model == 18 || this.formData.value.model == 19 || this.formData.value.model == 20) return true;
        return false;
      case 'dependent':
        if (this.formData.value.model == 11) return true;
        return false;
      default:
        break;
    }
  }
  disableGenerationBtn() {
    if (this.showValues('year') && this.formData.get('year') && !this.formData.value.year) return true;
    if (this.showValues('initialMonth') && this.formData.get('initialMonth') && !this.formData.value.initialMonth) return true;
    if (this.showValues('finalMonth') && this.formData.get('finalMonth') && !this.formData.value.finalMonth) return true;
    if (this.showValues('beneficiary') && this.formData.get('beneficiary') && !this.formData.value.beneficiary) return true;
    if (this.showValues('dependent') && this.formData.get('dependent') && !this.formData.value.dependent) return true;
    return false;
  }
  onBeneficiaryChange() {
    if (this.formData.value.product == 2) {
      this.yearsList = this.beneficiaries.find(b => b.beneficiaryId === this.formData.value.beneficiary).years.map((y: any) => {
        return { description: y };
      });
    }
  }
  onYearChange() {
    if (this.formData.value.product == 1) {
      this.formData.patchValue({ initialMonth: null, finalMonth: null });
      const foundYear = this.yearsList.find((y: any) => y.description == this.formData.value.year);
      this.initialMonthsList = this.defaultMonths.filter(dm => !!foundYear.months.find((month: any) => month == dm.number));
    }
  }
  onProductChange() {
    this.formData.patchValue({ year: null });
    this.formData.patchValue({ model: null });
    this.modelsList = null;
    this.yearsList = null;
    if (this.formData.value.product) {
      this.loadingModels = true;
      this.declarationService.getModelsUser(this.formData.value.product).subscribe({
        next: (models: any) => {
          this.modelsList = models;
          this.formData.get('model')?.reset();
          this.loadingModels = false;
        },
        error: (err: any) => {
          this.loadingModels = false;
        }
      });
    }
  }
}